import { put, call, takeLatest } from "redux-saga/effects";
import axios from "axios";
import { getUserSuccess } from "../admin/actions";
import { GET_SUBCRIPTIONSTATUS_REQUEST } from "./actions";
import { Env } from "../../env";

function* getSubcriptionStatusRequest(action) {
  let response;
  const { accessToken, userId, user } = action;
  // console.log(JSON.stringify(action));
  try {
    response = yield call(axios.get, `${Env.BASE_API_URL}/Accounts/status`, {
      headers: { Authorization: accessToken },
    });
  } catch (err) {
    if (err.response && err.response.status === 401) {
      // yield put(logoutRequest());
      // console.log('error');
    } else {
      // yield put(getSubcriptionError("Somthing is wrong"));
    }

    return;
  }

  yield put(getUserSuccess(user, response.data));
}
export default function* watchGetSubcriptionRequest() {
  yield takeLatest(GET_SUBCRIPTIONSTATUS_REQUEST, getSubcriptionStatusRequest);
}



// WEBPACK FOOTER //
// ./src/pages/quiz/saga.js